"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Accordion_1 = __importDefault(require("@mui/material/Accordion"));
const AccordionDetails_1 = __importDefault(require("@mui/material/AccordionDetails"));
const AccordionSummary_1 = __importDefault(require("@mui/material/AccordionSummary"));
const styled_components_1 = __importDefault(require("styled-components"));
const ExpandMore_1 = __importDefault(require("@mui/icons-material/ExpandMore"));
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const mui_1 = require("tss-react/mui");
const investments_svg_1 = __importDefault(require("assets/nav-menu/investments.svg"));
const core_1 = require("companion-app-components/utils/core");
const RendersCount_1 = __importDefault(require("components/RendersCount"));
const styles_1 = require("../styles");
const ValueField_1 = __importDefault(require("../ValueField"));
const log = (0, core_1.getLogger)('containers/InvestmentHoldingsCard/index.js');
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const GridLeft = (0, styled_components_1.default)(Grid_1.default) `text-align: left;`;
const GridRight = (0, styled_components_1.default)(Grid_1.default) `text-align: right;`;
const CompanyName = styled_components_1.default.div `
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 12px;
  font-weight: 300;
  padding-top: 4px;
`;
const SubHeader = styled_components_1.default.span `color: ${({ theme }) => theme.palette.text.secondary}; font-size: 12px;`;
const DetailPanel = styled_components_1.default.div `
  width: 50%;
  font-size: 14px;
  color: ${({ theme }) => theme.palette.text.primary};
`;
const DetailPanelLeft = (0, styled_components_1.default)(DetailPanel) `
  border-right: 1px solid ${({ theme }) => theme.palette.background.elevated};
  padding: 2px 2px 10px 2px;
  margin-bottom: 10px;
`;
const DetailPanelRight = (0, styled_components_1.default)(DetailPanel) `
  padding: 0 0 10px 25px;
  margin-bottom: 10px;
`;
const DetailPanelContent = (0, styled_components_1.default)(DetailPanel) `
  position: relative;
  float: left;
  padding: 0 30px 20px 0;
`;
const DetailPanelContentLeft = (0, styled_components_1.default)(DetailPanelContent) `text-align: left;`;
const DetailPanelContentLeftBottom = (0, styled_components_1.default)(DetailPanelContent) `text-align: left; padding-bottom: 0;`;
const DetailPanelContentRight = (0, styled_components_1.default)(DetailPanelContent) `text-align: right;`;
const DetailPanelContentRightBottom = (0, styled_components_1.default)(DetailPanelContent) `text-align: right; padding-bottom: 0;`;
const InvestmentHoldingCard = ({ holding, uiState, isLoading, sortedHoldings }) => {
    const { classes } = useStyles();
    const [expanded, setExpanded] = (0, react_1.useState)(uiState.selectedSecurityId === (holding === null || holding === void 0 ? void 0 : holding.id));
    const handleChange = (_, value) => {
        setExpanded(value);
    };
    let amountDelta = 0;
    let quoteChangePercentage = 0;
    if (holding) {
        amountDelta = holding.amountDelta;
        if (amountDelta !== 'N/A' && (holding.amount - amountDelta)) {
            quoteChangePercentage = ((amountDelta / (holding.amount - amountDelta)) * 100);
        }
        else {
            quoteChangePercentage = 'N/A';
        }
    }
    if (!isLoading && (!sortedHoldings || sortedHoldings.size === 0)) {
        log.debug('NO HOLDINGS!');
        return (<div>
        {uiState &&
                <div style={{ height: `${uiState.regWinHeight}px`, flexGrow: '1', overflow: 'scroll', textAlign: 'center' }}>
            <div className={classes.zeroStateContainer}>
              <div className={classes.zeroStateContent}>
                <img alt="no investments data" src={investments_svg_1.default}/>
                <div className={classes.zeroStateTextHeadline}>This account has no holdings</div>
              </div>
            </div>
          </div>}
      </div>);
    }
    return (<>
      {holding &&
            <Accordion_1.default key={holding.id} expanded={expanded} onChange={handleChange}>
          <AccordionSummary_1.default expandIcon={<ExpandMore_1.default />}>
            <Grid_1.default container direction="row" justifyContent="space-between" alignItems="flex-start">
              <Grid_1.default container direction="row" display="contents" justifyContent="space-between" alignItems="flex-start" spacing={0} mr={50}>
                <GridLeft item xs={3} style={{ fontWeight: '400' }}>
                  {holding.tickerSymbol || holding.companyName}
                  {holding.tickerSymbol &&
                    <CompanyName title={holding.companyName}>
                      {holding.companyName}
                    </CompanyName>}
                </GridLeft>
                <GridRight item xs={2}>
                  <ValueField_1.default inputValue={holding.latestPrice}/>
                  <br />
                  <SubHeader>QUOTE</SubHeader>
                </GridRight>
                <GridRight item xs={2}>
                  {Math.round(holding.numberOfShares)}
                  <br />
                  <SubHeader>SHARES</SubHeader>
                </GridRight>
                <GridRight item xs={2}>
                  <ValueField_1.default inputValue={holding.amount}/>
                  <br />
                  <SubHeader>MARKET VALUE</SubHeader>
                </GridRight>
                <GridRight item xs={3}>
                  <ValueField_1.default inputValue={amountDelta} color="sign"/>
                  <ValueField_1.default inputValue={quoteChangePercentage} color="sign" type="percentage"/>
                  {quoteChangePercentage !== 'N/A' &&
                    <br />}
                  <SubHeader>TODAY&rsquo;S CHANGE</SubHeader>
                </GridRight>
              </Grid_1.default>
            </Grid_1.default>
          </AccordionSummary_1.default>
          <AccordionDetails_1.default className={classes.accordionDetails}>
            <DetailPanelLeft>
              <DetailPanelContentLeft>Today&rsquo;s Open</DetailPanelContentLeft>
              <DetailPanelContentRight><ValueField_1.default inputValue={holding.openPrice}/></DetailPanelContentRight>
              <DetailPanelContentLeft>Previous Close</DetailPanelContentLeft>
              <DetailPanelContentRight><ValueField_1.default inputValue={holding.closePrice}/></DetailPanelContentRight>
              <DetailPanelContentLeft>Today&rsquo;s High</DetailPanelContentLeft>
              <DetailPanelContentRight><ValueField_1.default inputValue={holding.highestPrice}/></DetailPanelContentRight>
              <DetailPanelContentLeft>Today&rsquo;s Low</DetailPanelContentLeft>
              <DetailPanelContentRight><ValueField_1.default inputValue={holding.lowestPrice}/></DetailPanelContentRight>
              <DetailPanelContentLeftBottom>P/E</DetailPanelContentLeftBottom>
              <DetailPanelContentRightBottom><ValueField_1.default type="number" keepCents inputValue={holding.peRatio}/></DetailPanelContentRightBottom>
            </DetailPanelLeft>
            <DetailPanelRight>
              <DetailPanelContentLeft>52 Week High</DetailPanelContentLeft>
              <DetailPanelContentRight>
                <ValueField_1.default inputValue={holding.yearHighPrice}/>
              </DetailPanelContentRight>
              <DetailPanelContentLeft>52 Week Low</DetailPanelContentLeft>
              <DetailPanelContentRight>
                <ValueField_1.default inputValue={holding.yearLowPrice}/>
              </DetailPanelContentRight>
              <DetailPanelContentLeft>Volume</DetailPanelContentLeft>
              <DetailPanelContentRight>
                <ValueField_1.default type="number" inputValue={holding.volume}/>
              </DetailPanelContentRight>
              <DetailPanelContentLeft>Average Volume</DetailPanelContentLeft>
              <DetailPanelContentRight>
                <ValueField_1.default type="number" inputValue={holding.averageVolume}/>
              </DetailPanelContentRight>
              <DetailPanelContentLeftBottom>Div Yield</DetailPanelContentLeftBottom>
              <DetailPanelContentRightBottom>
                <ValueField_1.default type="percentage" noBrackets="true" inputValue={holding.divYield}/>
              </DetailPanelContentRightBottom>
              <DetailPanelContentLeft />
              <DetailPanelContentRight />
            </DetailPanelRight>
          </AccordionDetails_1.default>
        </Accordion_1.default>}
      {!holding && sortedHoldings &&
            <div>
          {sortedHoldings.valueSeq().map((hold) => (<react_1.Fragment key={`holding_${hold.id}`}>
              <RendersCount_1.default id={`investmentHoldingCard-${hold.id}`}/>
              <InvestmentHoldingCard holding={hold} isLoading={isLoading} // Pass through when recursive
                 sortedHoldings={sortedHoldings} uiState={uiState}/>
            </react_1.Fragment>))}
        </div>}
    </>);
};
exports.default = InvestmentHoldingCard;
